import { NextRouter } from 'next/router';

export function navigateWithTransition(router: NextRouter, href: string) {
  // @ts-ignore this ts version doesn't seem to recognize startViewTransition
  if (document.startViewTransition) {
    // @ts-ignore this ts version doesn't seem to recognize startViewTransition
    document.startViewTransition(() => router.push(href));
  } else {
    router.push(href); // Fallback for unsupported browsers
  }
}
